var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSyntheticAssets = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M19.1 22.4h-5.4v-1h4.4V20h1z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M19.1 20.2h-1V4.4h-4.4v-1h5.4zM17.5 22.4c-2.6-.6-3.1-2-3.4-2.9 0-.1-.1-.3-.1-.4s-.1-.1-.2-.1h-.1v-1c.2 0 .3 0 .5.1.3.1.6.4.8.7.1.1.1.3.2.4.3.8.6 1.8 2.6 2.2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M7.3 18.4h-1v-13c0-1.1.9-2 2-2h3.4v1H8.3c-.6 0-1 .4-1 1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M11.8 22.3H7.3c-1.3-.1-2.2-.5-2.8-1.3-.9-1.2-.6-2.7-.6-2.7l.1-.4h7.8v1h-7c0 .4.1 1 .5 1.5q.6.75 2.1.9h4.4z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M22.2 7.7h-3.6v-1h2.5c-.1-.8-.6-2.3-2.3-2.3h-.6v-1h.6c2.5 0 3.3 2.5 3.3 3.8z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M8.5 9h3.3v1H8.5zM8.5 11.5h3.3v1H8.5z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#BAD5DB",
  d: "M13.7 11.5H17v1h-3.3z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#00CFB3",
  d: "M12.7 24c-.3 0-.5-.2-.5-.5v-21c0-.3.2-.5.5-.5s.5.2.5.5v20.9c0 .3-.2.6-.5.6"
})));
export default SvgSyntheticAssets;